import { ModuleCommandEnum } from "@/types/enums/module-command.enum";
import { TFunction } from "i18next";

export const getAchivedStateForCommand = (
  command: ModuleCommandEnum,
  translator: TFunction
) => {
  let resultState: string | null = null;

  switch (command) {
    case ModuleCommandEnum.UP:
      resultState = translator("modulesStates.up");
      break;
    case ModuleCommandEnum.DOWN:
      resultState = translator("modulesStates.folded");
      break;
    case ModuleCommandEnum.CLOSE:
      resultState = translator("modulesStates.closedUp");
      break;
    case ModuleCommandEnum.OPEN:
      resultState = translator("modulesStates.unfolded");
      break;
  }

  if (!resultState) {
    throw new Error("No state found");
  }

  return resultState;
};
